import { Box } from "../../box";
import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerOverlayArrow({
  as = DefaultElement,
  forwardedRef,
  ...rest
}) {
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: "o-ui-overlay-arrow",
      ref: forwardedRef
    })
  });
}
InnerOverlayArrow.defaultElement = DefaultElement;
export const OverlayArrow = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerOverlayArrow, { ...props,
  forwardedRef: ref
}));